import $ from "jquery";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from "split-type";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/scss";

// Mid text animation
const splitText = new SplitType(".js-single-text-animation");

let singleSuiteTM = gsap.timeline({
  scrollTrigger: {
    trigger: ".js-text-reveal-animation-helper",
    start: "top 30%",
  },
});

singleSuiteTM.from(splitText.lines, {
  color: "rgba(45, 45, 45, 0.3)",
  duration: 1,
  stagger: 0.3,
});

// Intro image + info animation
gsap.to(".js-single-intro-image .mask", {
  top: "100%",
  delay: 0.3,
  duration: 0.3,
});
gsap.from(".js-single-info", {
  opacity: 0,
  y: 10,
  delay: 0.7,
  duration: 0.9,
});

const swiperContainer = new Swiper(".slider-container", {
  modules: [Navigation],
  slidesPerView: 1,
  loop: true,
  speed: 1000,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
